import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #4d4d4d;

  div {
    margin-right: 8px;
  }
`;
